import { store } from "../store/store"
import axios from 'axios'
import ApiController from "."

const { setCurrentUser } = require("../reducers/users")

const dispatch = store.dispatch

const all = {
    getAllData(){
        ApiController.users.getCurrentUser()
        ApiController.annonces.getAnnoncesList();
    },
}
export default all